/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Network configuration for the restored RDS database (Aurora cluster or RDS instance).
*/
export class RdsNativePitrNetworkConfig {
  /**
  * DB subnet group name. If not specified, uses the source database\'s subnet group. 
  */
  'subnetGroupName'?: string;
  /**
  * VPC security group IDs. If not specified, uses the source database\'s security groups. 
  */
  'securityGroupIds'?: Array<string>;
  /**
  * Whether the database should be publicly accessible.
  */
  'isPubliclyAccessible'?: boolean;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "subnetGroupName",
      "baseName": "subnetGroupName",
      "type": "string",
      "format": ""
    },
    {
      "name": "securityGroupIds",
      "baseName": "securityGroupIds",
      "type": "Array<string>",
      "format": ""
    },
    {
      "name": "isPubliclyAccessible",
      "baseName": "isPubliclyAccessible",
      "type": "boolean",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return RdsNativePitrNetworkConfig.attributeTypeMap;
  }

  public constructor() {
  }
}

